import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS, type BffEndpoint } from '../../endpoints/BffEndpoints';
import type { HttpResponse } from '../../http/HttpClient';
import type { PlanListQueryParams, PlansListResponse } from '../../models/bff/Plan';
import { BffApiClient } from '../../clients/BffApiClient';
import { filterQueryParams } from '../../../utils/queryParams';
import type { AddonsListResponse } from '../../models/bff';

const NAME = 'plans';

/**
 * PlanRepository class for handling plan-related API operations.
 * Uses the BFF API client by default but can be switched to other API clients.
 * Type-safe: Only allows BFF endpoints defined in BFF_ENDPOINTS.
 */
export class PlanRepository extends BaseRepository<BffEndpoint> {
  static override name = NAME;

  constructor() {
    super(BffApiClient.getInstance());
  }

  /**
   * Retrieve all available plans filtered for a given criteria.
   *
   * @param queryParams - The flight search criteria
   * @returns Promise<HttpResponse<PlansListResponse>> - The available plan list
   */
  list(queryParams?: PlanListQueryParams): Promise<HttpResponse<PlansListResponse>> {

    const filteredParams = filterQueryParams(queryParams);

    return this.apiClient.get<PlansListResponse>(
      BFF_ENDPOINTS.PLAN_LIST,
      {
        query: filteredParams,
      },
    );
  }

  getAddons(planCode: string): Promise<HttpResponse<AddonsListResponse>> {
    return this.apiClient.get<AddonsListResponse>(
      BFF_ENDPOINTS.ADDON_LIST,
      {
        pathParams: { plan_code: planCode },
      },
    );
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: PlanRepository;
  }
}